import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Content from 'components/common-sfims/Content';
import List from 'components/common-sfims/List';
import { childrenComponent2Object } from 'function/convert';
import isEmpty from 'utils/isEmpty';

/**
 * 목록 (내용 포함)
 */
const ListInContent = ({
  children,
  className,
  columns,
  hover,
  message,
  showLoading,
  tableRef
}) => {
  /* variable */
  const { title, headerButton, search, datas, pagination, footerButton } =
    childrenComponent2Object(children);

  /* view */
  return (
    <Content
      className={{
        body: 'pt-0',
        ...className
      }}
    >
      <Fragment key="title">{title}</Fragment>
      <Fragment key="headerButton">{headerButton}</Fragment>
      <Fragment key="body">
        {!isEmpty(search?.props?.children) && (
          <Form.Group className="mb-3">{search}</Form.Group>
        )}
        <List
          className={className}
          columns={columns}
          message={message}
          showLoading={showLoading}
          tableRef={tableRef}
          hover={hover}
        >
          {datas}
        </List>
        {pagination}
      </Fragment>
      {!isEmpty(footerButton?.props?.children) && (
        <Fragment key="footerButton">{footerButton}</Fragment>
      )}
    </Content>
  );
};

ListInContent.propTypes = {
  // 클래스 이름
  className: PropTypes.shape({
    headerButton: PropTypes.string,
    body: PropTypes.string,
    table: PropTypes.string,
    thead: PropTypes.string,
    tbody: PropTypes.string
  }),

  // 컬럼 목록
  // NOTE: Element를 포함할 수 있으므로 타입 유효성 확인 예외 처리
  columns: PropTypes.array,
  // columns: PropTypes.arrayOf(
  //   PropTypes.oneOfType([
  //     PropTypes.string,
  //     PropTypes.shape({
  //       text: PropTypes.string,
  //       className: PropTypes.string,
  //       colSpan: PropTypes.number,
  //       style: PropTypes.object,
  //       childrens: PropTypes.arrayOf(PropTypes.string),
  //       onClick: PropTypes.func
  //     })
  //   ])
  // ),

  // 마우스 오버 시 배경 색 표시 여부
  hover: PropTypes.bool,

  // 메시지
  message: PropTypes.shape({
    code: PropTypes.string,
    error: PropTypes.string
  }),

  // 로딩 표시 여부
  showLoading: PropTypes.bool
};
ListInContent.defaultProps = {
  className: {
    table: '',
    thead: ''
  },
  columns: [],
  hover: true,
  message: {},
  showLoading: false,
  tableRef: null
};

export default ListInContent;
